const data = {
  slides: [
    {
      "Slide Number": "1",
      "Card Empty":".",
      "Title":
      "The hidden casualties of Britain's war"
      +"\r\n\r\n Searching for the victims of UK airstrikes in Iraq and Syria"
      +"\r\n\r\n March 21, 2023",
      "Screen Image Title":"MobileFrames/Documents_FramesMobile047.jpg",
      "Text Image":"MobileFrames/Documents_FramesMobile047.jpg",
    },
    {
      "Slide Number": "2",
      "Text Title": "In eight years of bombing the so-called Islamic State, the UK claims to have killed just one civilian."
      +"\r\n\r\n An investigation by Airwars and The Guardian has identified dozens more civilians potentially killed by UK strikes.",
      "Text Video":'{"src":"assets/Drone_intro.mp4", "poster":"assets/Drone_introscreenshot.4"}',
      "Scroll Video":"30",
      "Image Caption":
      "Footage of UK airstrikes"
      +"\r\n\r\n Source: Royal Air Force", 
      Bounds: "[35.92, 31.59, 46.76, 38.94]",
    },
    {
      "Slide Number": "3",
      "Text Long": "Since 2014, the Global Coalition Against Daesh has carried out thousands of airstrikes in Iraq and Syria."
      +"\r\n\r\n For the past nine years, journalists, campaigners and even military figures have cast doubt on the UK's figure."      
      +"\r\n\r\n Now, two sets of newly declassified documents led us to identify eight more strikes which may have been conducted by the UK. In these cases, the Coalition accepts that at least 32 civilians were killed.",
      Bounds: "[35.92, 31.59, 46.76, 38.94]",
      "Screen Image": "assets/Coalitionmap.png",
      "Map":"0",
    },
    {
      "Slide Number": "4",
      "Card Empty":".",
      "Card Content":"Through Freedom of Information Act (FOIA) requests, Airwars obtained the dates and locations of the 1,166 weapons releases in which the UK claimed its strikes killed or harmed ISIS militants. The Ministry of Defence claims these strikes killed exactly 4,069 militants - 3,052 in Iraq, 1,017 in Syria.", 
      "In Slide Link":"https://airwars.org/conflict-data/british-ekia/",
      "Screen Image": "assets/Coalitionmap.png",
      "Scroll Video":"0",
      "Map":"0",
      Bounds: "[35.92, 31.59, 46.76, 38.94]",
    },
    {
      "Slide Number": "5",
      "Card Content":
      "Over a year we compared and matched hundreds of documents to identify eight strikes that we believe are likely British.",
      "Source": "Source: ",
      Bounds: "[43.11, 36.33, 43.12, 36.34]",
      "Scroll Video":"30",
    },
    {
      "Slide Number": "6",
      "Card Content":
      "We reviewed every single strike detailed in the FOIA documents.",
      "Source": "Source: ",
      Bounds: "[43.11, 36.33, 43.12, 36.34]",
      "Scroll Video":"30",
    },
    {
      "Slide Number": "7",
      "Card Content":
      "We matched them to the Ministry of Defence's original statements explaining what they were targeting.",
      "Source": "Source: ",
      Bounds: "[35.92, 31.59, 46.76, 38.94]",
      "Scroll Video":"30",
    },
    {
      "Slide Number": "8",
      "Card Content":
      "Next, we cross-referenced this information with the Coalition's statements about their actions on those specific dates.",
      "Source": "Source: ",
      Bounds: "[35.92, 31.59, 46.76, 38.94]",
      "Scroll Video":"30",
      "Map":"0",
    },
    {
      "Slide Number": "9",
      "Card Content":
      "We then compared this information to Airwars' database of civilian harm events, making sure the dates, locations and details matched up, as well as whether the Coalition had accepted responsibility.",
      "Source": "Source: ",
      Bounds: "[35.92, 31.59, 46.76, 38.94]",
      "Scroll Video":"30",
      "Map":"0",
    },
    {
      "Slide Number": "10",
      "Card Content":
      "Finally, we matched them with declassified Coalition assessments of civilian harm released to <l>The New York Times(https://www.nytimes.com/interactive/2021/us/civilian-casualty-files.html)</l> in 2021."
      +"\r\n\r\n Although the nation responsible was always redacted, each one contained vital details about specific strikes including chat logs and timestamps.",
      Bounds: "[35.92, 31.59, 46.76, 38.94]",
      "Scroll Video":"30",
      "Map":"0",
    },
    {
      "Slide Number": "11",
      "Card Content":"We found 41 initial potential matches. As many contained few specific details, we focused on those we had the most evidence for.", 
      "Map":"30",
      "Scroll Video":"0",
      Bounds: "[35.92, 31.59, 46.76, 38.94]",
    },
    {
      "Slide Number": "12",
      "Card Content":
      "In total we identified eight cases where all key details suggested they were British strikes.",
      Bounds: "[35.92, 31.59, 46.76, 38.94]",
      "Map":"30",
    },
    {
      "Slide Number": "13",
      "Card Content":
      "Working with <l>The Guardian(https://www.theguardian.com/world/2023/mar/21/british-airstrikes-mosul-civilian-victims-iraq)</l>, we visited Iraq to search for the victims mentioned in the original casualty allegations and piece together what happened. One of those we found was the Younis family in Mosul.",
      Bounds: "[43.10, 36.3, 43.20, 36.4]",
      "Map":"30",
    },
    {
      "Slide Number": "14",
      "Card Content":
      "A strike on November 29, 2016 killed six-year-old Taiba Younis, and badly injured her mother and siblings."
      +"\r\n\r\n We reconstructed this incident, through interviews, the declassified Coalition assessment and 3-D modelling.",
      Bounds: "[43.19, 36.362, 43.20, 36.366]",
      "Map":"30",
    },
    {
      "Slide Number": "16",
      "Scroll Video":"0",
      "Text Youtube": "https://www.youtube.com/embed/-YTaxu0R5og",
    },
    {
      "Slide Number": "17",
      "Text Long":
      "Airwars sent these findings to the Ministry of Defence in July 2022, including all the relevant statements and corroborating evidence to explain how we reached our conclusions. The ministry declined to review the evidence in detail or discuss individual cases, but a spokesman said:"
      +'\r\n\r\n "The MOD examines all the evidence available to us, including a comprehensive assessment of all available mission data, and [has] seen nothing that indicates civilian casualties were caused.'
      +'\r\n\r\n “We always seek to minimise the risk of civilian casualties through our rigorous targeting processes, but that risk can never be removed entirely, particularly given the ruthless and inhumane behaviour of the adversary, including the deliberate use of human shields."'
      +'\r\n\r\n We have sought to discuss the findings multiple times with MoD officials in the months since, without success.'
      +"\r\n\r\n In 2020, Airwars brought <l>three other cases(https://www.bbc.co.uk/news/uk-51900898)</l> of civilian harm in confirmed British strikes to the Ministry of Defense. In each case, the Coalition said that there was civilian harm as a result of these strikes – but the MoD did not agree."
      +"\r\n\r\n Politicians, campaigners and civil society groups have consistently raised concerns about the UK's lack of civilian harm monitoring and accountability in Iraq and Syria. The Netherlands has since paid millions in <l>compensation(https://www.defense.gov/News/Releases/Release/Article/2914764/department-of-defense-releases-memorandum-on-improving-civilian-harm-mitigation/)</l> to <l>victims(https://apnews.com/article/iraq-netherlands-archive-daf592901acafd7afe9c6a1ed1225ef9)</l> of its strikes, while the United States has launched <l>major policy reforms(https://theintercept.com/2022/10/29/iraq-hawija-airstrike-accountability/)</l> to learn the lessons of the campaign. The UK remains an outlier, claiming it had robust mechanisms for monitoring the impact of its strikes - including post strike battle damage assessments - and refusing to review its policies."
      +"\r\n\r\n Civilian victims of UK airstrikes can theoretically claim condolence payments from the British government, but those seeking to do so would face severe procedural and legal hurdles. The UK has not publicly compensated a single victim of a British airstrike and there is <l>no clear process(https://www.ceasefire.org/wp-content/uploads/2021/12/CFR_Reparations_Nov21_Final.pdf)</l> for victims and their families to apply."
      +'\r\n\r\n Lydia Day, advocacy director at the Ceasefire Centre for Civilian Rights NGO, said government policy on compensation was "getting worse." “The UK public position on airstrikes is that they are done as part of a coalition and the UK doesn’t kill any civilians [on its own]."' 
      +'\r\n\r\n “The system is just built in a way where they just really do not want anyone to try and claim compensation,” said Day. “What’s interesting is that if you speak to anyone in the know [in the military or ministry of defence], they know that this is a ridiculous scenario.”'
      +'\r\n\r\n In 2021, the Overseas Operations Act introduced a six year limit on all civilian claims for compensation resulting from UK forces’ actions, meaning many families of victims killed in Iraq and Syria would no longer be eligible.'
      +"\r\n\r\n The UK remains militarily active in Iraq and Syria – and the levels of secrecy around its campaign persist. As recently as December 2022, <l>the UK carried out a strike on a militant(https://hansard.parliament.uk/commons/2023-03-13/debates/59F6F12A-7C38-4DD2-BAB0-30208E8D3F7B/OralAnswersToQuestions#contribution-1C18CD30-F963-4A13-898F-637AB56EE5EE)</l> who was allegedly involved in activity around biological and chemical weapons, in al-Bab, northern Syria. <l>Local media reported allegations of civilian harm(https://airwars.org/civilian-casualties/cs1989-december-20-2022/)</l> almost immediately after the strike, with  at least two civilians reportedly injured. Airwars alerted an official within the MoD to this incident in January, and has been seeking to identify a formal mechanism to submit such allegations. The ministry has yet to provide clarity on this procedure."
      +"\r\n\r\n  <bl>___ </bl>"
      +"\r\n\r\n Reporting from Airwars: <l>Sanjana Varghese(https://twitter.com/sanjanamv)</l>, <l>Júlia Nueno(https://twitter.com/julnueno)</l>, <l> Joe Dyke(https://twitter.com/joedyke)</l>, <l>Imogen Piper(https://twitter.com/imogen_piper)</l>, Salim Habib"
      +"\r\n\r\n Reporting from The Guardian: <l>Emma Graham-Harrison(https://twitter.com/_EmmaGH)</l>"
      +"\r\n\r\n Visuals: <l>Júlia Nueno(https://twitter.com/julnueno)</l>, <l>Azul De Monte(https://twitter.com/azul_demonte)</l>"
      +"\r\n\r\n Additional Research: Anna Zahn, Clive Vella, Felix Porée"
      +"\r\n\r\n Additional Development Support: <l>Rectangle(https://rectangle.design/)</l>",
      "Share": 
      "https://airwars.org/britains-hidden-civilian-harm" ,
      Bounds: "[43.19, 36.362, 43.20, 36.366]",
      "Text Long After": "<bl>___ </bl>",
      "Scroll Video":"10",
      "Map":"0",
    },
  ],
  frames: [
    {
      "Slide Num": "2",
      "Start Frame": "000", 
      "End Frame": "000", 
    },
    {
      "Slide Num": "4",
      "Start Frame": "001", 
      "End Frame": "055", 
    },
    {
      "Slide Num": "5",
      "Start Frame": "055", 
      "End Frame": "080", 
    },
    {
      "Slide Num": "6",
      "Start Frame": "089", 
      "End Frame": "110", 
    },
    {
      "Slide Num": "7",
      "Start Frame": "111", 
      "End Frame": "139",
    },
    {
      "Slide Num": "8",
      "Start Frame": "139", 
      "End Frame": "160", 
    },
    {
      "Slide Num": "9",
      "Start Frame": "161", 
      "End Frame": "191", 
    },
    {
      "Slide Num": "10",
      "Start Frame": "191", 
      "End Frame": "191", 
    },
  ],
}


export default data;